<div class="inner-container">
  @if (isloading) {
    <mat-progress-bar mode="indeterminate" value="80" class="mb-15"> </mat-progress-bar>
  } @else {
    <div class="warning-banner" role="note">
      Not all tenant solutions support disable from the admin portal. Before disabling a solution, confirm that the
      selected solution supports this workflow.
    </div>

    <table mat-table [dataSource]="dataSource" matSort>

      <!-- Solution Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let element">{{ element.status }}</td>
      </ng-container>

      <!-- Action Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
        <td mat-cell *matCellDef="let element">
          <div class="action-group">
          @if (element.status === 'configured') {
            <mat-slide-toggle class="mat-accent" [checked]="isEnabled(element)" [labelPosition]="'after'"
              [hideIcon]="true" [disabled]="!canToggleState(element)"
              (change)="changeStatus($event, element.solution_id)">
              <p class="label">Enabled</p>
            </mat-slide-toggle>
          }
          @if (canDisableSolution(element)) {
            <button
              mat-flat-button
              color="primary"
              class="secondary-btn"
              type="button"
              [disabled]="disableInFlightSolutionIds.has(element.solution_id)"
              (click)="disableSolution(element)">
              Disable
            </button>
          }
          @if (element.status.toLowerCase() === 'available') {
            <button mat-flat-button color="primary" class="primary-btn"
              routerLink="tenant-solutions/{{ element.solution_id }}" [queryParams]="{'tenantId': tenantId}"
              routerLinkActive="active" ariaCurrentWhenActive="page" #darsettings="routerLinkActive">
              Configure
            </button>
          }
          @if (element.status.toLowerCase() != 'available') {
            <button mat-flat-button color="primary" routerLink="tenant-solutions/{{ element.solution_id }}"
              [queryParams]="{'tenantId': tenantId}" routerLinkActive="active" class="secondary-solid-btn"
              ariaCurrentWhenActive="page" #darsettings="routerLinkActive">
              View
            </button>
          }
          </div>
        </td>
      </ng-container>

      <tr class="header-shadow" mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td style="text-align: center; line-height: 40px;" class="mat-cell" [attr.colspan]="displayedColumns.length">
          No entitled solutions.
        </td>
      </tr>
    </table>

    <div class="btn-group mb-15" style="margin-top: 32px;">
      <button
        mat-flat-button
        color="primary"
        type="button"
        class="secondary-btn"
        [disabled]="isloading"
        [routerLink]="['/tenants']">
        Back
      </button>

    </div>
  }
</div>
